// extracted by mini-css-extract-plugin
export default {"message":"AlertBox_message__xR+oC"};